import relatedProducts from '../../../mocks/relatedProducts';

export default function RelatedProducts() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-8">관련 제품</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {relatedProducts.map((product) => (
          <a
            key={product.id}
            href={product.link}
            className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg transition-all cursor-pointer"
          >
            <div className="aspect-square bg-gray-50 overflow-hidden">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform"
              />
            </div>
            <div className="p-4">
              <h3 className="font-medium text-gray-900 mb-2 line-clamp-2 group-hover:text-teal-600 transition-colors">
                {product.name}
              </h3>
              <div className="flex items-baseline gap-2">
                <span className="font-bold text-teal-600">구매협의</span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}